var React = require('react');

function Star15 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m8 1 1.587 3.816 4.12.33-3.14 2.688.96 4.02L8 9.7l-3.527 2.154.959-4.02-3.139-2.688 4.12-.33L8 1Z","fill":"currentColor"}));
}

Star15.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Star15;

Star15.default = Star15;
